'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import AppLayout from '@/components/AppLayout';
import JobListingsHeader from './components/JobListingsHeader';
import JobFiltersBar from './components/JobFiltersBar';
import JobListingsTable from './components/JobListingsTable';
import { createClient } from '@/lib/supabase/client';
import { Loader2, Lock, CreditCard } from 'lucide-react';

export default function JobListingsPage() {
  const router = useRouter();
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const supabase = createClient();
    supabase?.auth?.getSession()?.then(({ data: { session } }) => {
      setIsAuthenticated(!!session);
      setAuthChecked(true);
    });
  }, []);

  if (!authChecked) {
    return (
      <AppLayout>
        <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-6">
          <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center">
            <Loader2 size={32} className="text-primary animate-spin" />
          </div>
          <p className="text-sm text-muted-foreground">Loading…</p>
        </div>
      </AppLayout>
    );
  }

  if (!isAuthenticated) {
    return (
      <AppLayout>
        <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-6">
          <div className="w-16 h-16 bg-amber-50 rounded-2xl flex items-center justify-center">
            <Lock size={32} className="text-amber-500" />
          </div>
          <div className="text-center max-w-md">
            <p className="text-lg font-700 text-foreground">Sign Up Required</p>
            <p className="text-sm text-muted-foreground mt-2">
              You need to register and complete payment to browse all job listings.
            </p>
          </div>
          <a
            href="/#signup"
            className="inline-flex items-center gap-2 bg-primary text-white text-sm font-600 px-5 py-2.5 rounded-xl hover:bg-primary/90 transition-colors"
          >
            <CreditCard size={16} />
            Register Now
          </a>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-8 space-y-6">
        <JobListingsHeader />
        <JobFiltersBar />
        <JobListingsTable />
      </div>
    </AppLayout>
  );
}